<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    :full-width-actions="false"
    dense
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.username="{ header, data, value: v }">
      <router-link
        v-if="!!header.getRoute"
        class="BTablePublicationFormdata__link"
        :to="header.getRoute(data)"
        v-text="v"
      />
      <span v-else v-text="v" />
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import { EXPERT_TABLE_ACTIONS, EXPERT_TABLE_HEADERS } from '@/views/LKMunMeh/Form/table-headers'
import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTablePublicationFormdata',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => EXPERT_TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => EXPERT_TABLE_ACTIONS,
    },
  },
}
</script>
